export enum WireAnalyticsEvent {
  FormStepComplete = 'formStepComplete',
  ViewLoaded = 'viewLoaded',
  SaveQuote = 'saveQuote',
  EmailQuote = 'emailQuote',
  ResumeQuote = 'resumeQuote',
  RetrieveQuoteStart = 'retrieveQuoteStart',
  RetrieveQuoteComplete = 'retrieveQuoteComplete',
  FindCar = 'findCar',
  CarNotFound = 'carNotFound',
  ManualSearch = 'manualSearch',
  CarNotAvailable = 'carNotAvailable',
  AddDriver = 'addDriver',
  DriverAdded = 'driverAdded',
  OptionalExtras = 'optionalExtras',
  AddPolicy = 'addPolicy',
  QuoteReferred = 'quoteReferred',
  QuoteDeclined = 'quoteDeclined',
  FindOutMore = 'findOutMore',
  CallUs = 'callUs',
  Edit = 'edit',
  Error = 'error',
  SubmitQuote = 'submitQuote',
}

export enum WireFunnelType {
  Motor = 'motor',
  Home = 'home',
  Landlord = 'landlord',
}

export enum WirePolicyIssued {
  Business = 'business',
  Personal = 'personal',
  Unspecified = '',
}

export type WirePage = {
  pageName: string;
  pageUrl: string;
  siteSection: string;
  siteServer: string;
  stepName: string;
  timeStamp?: string;
  errorDetails?: string;
  campaignCodePrefilled?: string;
  campaignCodeApplied?: string;
  promoCodePrefilled?: string;
  promoCodeManual?: string;
  colesCampaignCode?: string;
};

export type WirePayment = {
  method: string;
  terms: string;
};

export type WireFormDataBase = {
  quoteNumber: string;
};

export type WireFormData = WireFormDataBase & {
  productType: string;
  productSubtype: string;
  flybuysStatus: boolean;
  payment: WirePayment;
};

export type WireError = {
  type: string;
  message: string;
  pageName: string;
};

export type WireAnalytics = {
  event: WireAnalyticsEvent;
  page: WirePage;
  error?: WireError;
};
